import { FiCheck } from "react-icons/fi";
import { getDispatchBadges, getDispatchBadgeStyles } from "../../../Utils/DispatchBadgeHelpers";


const OrderListItem = ({
  order,
  isActive,
  onClick,
  quotationCount,
  hasSelectedQuotation,
}) => {
  const stageStyle = (() => {
    switch (order.stages) {
      case "Completed":
        return {
          dot: "bg-emerald-500",
          text: "text-emerald-600",
          bg: "bg-emerald-50 border-emerald-200",
        };
      case "Quotation":
        return {
          dot: "bg-blue-500",
          text: "text-blue-600",
          bg: "bg-blue-50 border-blue-200",
        };
      case "Sampling":
        return {
          dot: "bg-purple-500",
          text: "text-purple-600",
          bg: "bg-purple-50 border-purple-200",
        };
      case "Order-Fullfillment":
        return {
          dot: "bg-orange-500",
          text: "text-orange-600",
          bg: "bg-orange-50 border-orange-200",
        };
      default:
        return {
          dot: "bg-gray-400",
          text: "text-gray-500",
          bg: "bg-gray-50 border-gray-200",
        };
    }
  })();

  const varietyImg = order.productVariety?.img;
  const productImg = order.product?.img;
  const displayImg = varietyImg || productImg;

  // ✅ NEW: Get dispatch badges
  const dispatchBadges = getDispatchBadges(order);

  return (
    <div
      onClick={onClick}
      className={`group relative rounded-xl border cursor-pointer transition-all duration-200 overflow-hidden
        ${isActive
          ? "border-[#772037] bg-[#772037]/[0.03] shadow-md shadow-[#772037]/10"
          : "border-gray-200 bg-white hover:border-[#772037]/40 hover:shadow-sm"
        }`}
    >
      <div
        className={`absolute left-0 top-0 bottom-0 w-1 rounded-l-xl transition-all duration-200
        ${isActive
            ? "bg-gradient-to-b from-[#772037] to-[#CC234F]"
            : "bg-transparent group-hover:bg-[#772037]/20"
          }`}
      />

      <div className="pl-3 pr-3 pt-3 pb-3 ml-1">
        <div className="flex items-start gap-3">
          <div
            className={`w-13 h-13 rounded-xl overflow-hidden flex-shrink-0 border
            ${isActive ? "border-[#772037]/20" : "border-gray-100"}`}
            style={{ width: 52, height: 52 }}
          >
            {displayImg ? (
              <img
                src={displayImg}
                alt={
                  order.productVariety?.varietyName || order.product?.name
                }
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center bg-gray-50 text-2xl">
                📦
              </div>
            )}
          </div>

          <div className="flex-1 min-w-0">
            <p
              className={`text-[10px] font-bold uppercase tracking-widest mb-0.5
              ${isActive ? "text-[#772037]/70" : "text-gray-400"}`}
            >
              {order.orderNumber || `#${order._id?.slice(-6)}`}
            </p>
            <h3
              className={`font-bold text-sm leading-tight truncate
              ${isActive ? "text-[#772037]" : "text-gray-800"}`}
            >
              {order.product?.name || "—"}
            </h3>
            {order.productVariety?.varietyName && (
              <p className="text-xs text-gray-400 font-medium truncate mt-0.5">
                {order.productVariety.varietyName}
                {order.productVariety?.grade && (
                  <span className="ml-1 text-[9px] font-bold px-1 py-px rounded bg-gray-100 text-gray-500 uppercase">
                    {order.productVariety.grade}
                  </span>
                )}
              </p>
            )}

            <div className="flex items-center gap-1.5 mt-1.5 flex-wrap">
              {hasSelectedQuotation && (
                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold bg-emerald-50 text-emerald-600 border border-emerald-200">
                  <FiCheck className="text-[10px]" /> Selected
                </span>
              )}
              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold bg-blue-50 text-blue-600 border border-blue-200">
                {quotationCount || 0} Quotes
              </span>
            </div>
          </div>
        </div>

        <div className="my-2 border-t border-dashed border-gray-100" />

        <div className="flex items-center justify-between gap-2 flex-wrap">
          <div className="flex items-center gap-1 text-gray-400">
            <svg
              className="w-3 h-3"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <span className="text-[10px] font-medium">
              {new Date(order.createdAt).toLocaleDateString("en-GB", {
                day: "numeric",
                month: "short",
              })}
            </span>
          </div>

          <div className="flex items-center gap-1.5 flex-wrap">
            <span
              className={`inline-flex items-center gap-1 px-2 py-1 rounded-lg text-[10px] font-bold border ${stageStyle.bg} ${stageStyle.text}`}
            >
              <span
                className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${stageStyle.dot} ${order.stages !== "Completed" && order.stages !== "Closed"
                  ? "animate-pulse"
                  : ""
                  }`}
              />
              {order.stages?.replace(/_/g, " ") || "Pending"}
            </span>
          </div>
        </div>

        {/* ✅ NEW: DISPATCH BADGES SECTION ─────────────────────────────────── */}
        {dispatchBadges.length > 0 && (
          <div className=" pt-2.5 border-t border-dashed border-gray-100">
            <div className="flex items-center gap-1.5 flex-wrap">
              {dispatchBadges.map((badge, idx) => (
                <span
                  key={idx}
                  className={`inline-flex items-center gap-1 px-2 py-1 rounded-lg text-[10px] font-bold border ${getDispatchBadgeStyles(badge.color)}`}
                  title={`${badge.displayType} - ${badge.label}`}
                >
                  <span className="text-xs">{badge.icon}</span>
                  <>
                    {badge.displayType}
                    {badge.count > 1 && ` (${badge.count})`}
                  </>
                </span>
              ))}
            </div>
            {/* Status details */}
            <p className="text-[9px] font-semibold text-primaryColor mt-1">
              {dispatchBadges
                .map(
                  (b) =>
                    `${b.displayType}: ${b.label}${b.count > 1 ? ` (${b.count})` : ""
                    }`
                )
                .join(" • ")}
            </p>
          </div>
        )}

        {order.category?.name && (
          <p className="mt-2 text-[10px] text-gray-400 font-medium truncate">
            {[order.category?.name, order.subCategory?.name]
              .filter(Boolean)
              .join(" › ")}
          </p>
        )}
      </div>
    </div>
  );
};

export default OrderListItem;